/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatListItemResponse } from '../../models/chat-list-item-response';

export interface GetChatListSingleChat$Params {
  id: number;
}

export function getChatListSingleChat(http: HttpClient, rootUrl: string, params: GetChatListSingleChat$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatListItemResponse>> {
  const rb = new RequestBuilder(rootUrl, getChatListSingleChat.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatListItemResponse>;
    })
  );
}

getChatListSingleChat.PATH = '/api/chat/list/{id}';
